'use strict';

var Sugar = require('sugar-core');

require('./build/buildMathAliasesCall');

module.exports = Sugar.Number.abs;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/abs.js
// module id = 648
// module chunks = 0